"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var client_1 = require("@apollo/client");
var useCheckoutContext_1 = require("./useCheckoutContext");
var globalTypes_1 = require("../../../__generated__/globalTypes");
var UrlParamTypes_1 = require("../../../common/enum/UrlParamTypes");
var cache_1 = require("../graphql/cache");
var useGetConfigurationUrl = function () {
    var _a;
    var deal = useCheckoutContext_1.default().deal;
    var _b = ((_a = deal) === null || _a === void 0 ? void 0 : _a.car) || {}, code = _b.code, configurationSourceUrl = _b.configurationSourceUrl;
    var journeyType = client_1.useReactiveVar(cache_1.activeJourneyType);
    var getConfigurationUrl = react_1.useCallback(function () {
        if (journeyType === globalTypes_1.JourneyType.online_order || journeyType === globalTypes_1.JourneyType.reserve_online) {
            return configurationSourceUrl + "?" + UrlParamTypes_1.UrlParamTypes.REVERT_TO_BYO + "=" + code + "&" + UrlParamTypes_1.UrlParamTypes.NO_MODAL + "=true";
        }
        return configurationSourceUrl;
    }, [journeyType, code, configurationSourceUrl]);
    return { getConfigurationUrl: getConfigurationUrl };
};
exports.default = useGetConfigurationUrl;
